var _path, _rect, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVouchers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 29,
    viewBox: "0 0 46 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0821 13.3522C10.541 13.3522 9.47543 12.2374 9.47543 10.598C9.47543 8.97499 10.541 7.86019 12.0821 7.86019C13.6067 7.86019 14.6724 8.97499 14.6724 10.598C14.6724 12.2374 13.6067 13.3522 12.0821 13.3522ZM11.9509 19.5H10.3771L18.6889 8.02413H20.2791L11.9509 19.5ZM12.0821 12.1718C12.787 12.1718 13.2789 11.5325 13.2789 10.598C13.2789 9.64715 12.787 8.97499 12.0821 8.97499C11.3444 8.97499 10.8525 9.64715 10.8525 10.598C10.8525 11.5325 11.3444 12.1718 12.0821 12.1718ZM18.5742 19.6639C17.0331 19.6639 16.0003 18.5327 16.0003 16.8933C16.0003 15.2703 17.0331 14.1555 18.5742 14.1555C20.1152 14.1555 21.1808 15.2703 21.1808 16.8933C21.1808 18.5327 20.1152 19.6639 18.5742 19.6639ZM18.5742 18.4836C19.2955 18.4836 19.8037 17.8442 19.8037 16.8933C19.8037 15.9425 19.2955 15.2703 18.5742 15.2703C17.8528 15.2703 17.361 15.9425 17.361 16.8933C17.361 17.8442 17.8528 18.4836 18.5742 18.4836Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.09375,
    y: 1.03125,
    width: 43.8125,
    height: 26.9375,
    rx: 4.40625,
    stroke: "black",
    strokeWidth: 1.1875
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 33.9753,
    y1: 3.95312,
    x2: 33.9753,
    y2: 25.0469,
    stroke: "black",
    strokeWidth: 1.31944,
    strokeDasharray: "2.64 2.64"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVouchers);
export default __webpack_public_path__ + "static/media/vouchers.27a4f3be8ebe37d7f7699ba63a7d7994.svg";
export { ForwardRef as ReactComponent };